/** Shapes — the plain, essential freehand mark. The baseline create module. */
import type { CreateModule, ModuleContext } from '../../core/module-api';
import { cfgNum } from '../../core/module-api';
import type { Point, Shape } from '../../core/scene';
import { defaultStyle } from '../../core/scene';
import { buildSmoothPath, distance } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17c3-6 5-9 7-9s2 5 4 5 3-4 6-7"/></svg>';

export function createShapes(): CreateModule {
  let points: Point[] = [];
  let drawing = false;

  return {
    manifest: {
      id: 'shapes',
      kind: 'create',
      name: 'Shapes',
      apiVersion: 1,
      description: 'Freehand drawing — the plain, essential mark.',
      icon: ICON,
      params: [{ kind: 'slider', key: 'lineWidth', label: 'Weight', min: 0.5, max: 24, step: 0.5, default: 2 }],
    },

    onPointerDown(s) {
      points = [{ x: s.x, y: s.y }];
      drawing = true;
    },

    onPointerMove(s) {
      if (!drawing) return;
      const p = { x: s.x, y: s.y };
      const lastP = points[points.length - 1];
      if (!lastP || distance(lastP, p) >= 1.2) points.push(p);
    },

    onPointerUp() {
      drawing = false;
    },

    getLiveShapes(ctx: ModuleContext): Shape[] {
      if (points.length === 0) return [];
      const style = defaultStyle();
      style.color = { ...ctx.ink };
      style.lineWidth = cfgNum(ctx.config, 'lineWidth', 2);
      return [ctx.newShape({ path: buildSmoothPath(points), style })];
    },

    onClear() {
      points = [];
    },

    onCommit() {
      points = [];
    },
  };
}
